import(/* webpackMode: "eager" */ "/opt/hotlistcasino/frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["Breadcrumbs"] */ "/opt/hotlistcasino/frontend/src/components/Breadcrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocalizedLink"] */ "/opt/hotlistcasino/frontend/src/components/LocalizedLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MotionReveal"] */ "/opt/hotlistcasino/frontend/src/components/MotionReveal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MotionStagger"] */ "/opt/hotlistcasino/frontend/src/components/MotionStagger.tsx");
